<template>
  <div :class="$style.avatarBlock">
    <div :class="[$style.imgTextCol, 'text-caption', avatar_col_class]">
      <b>
        Фотография
      </b>
      <span>
        (Помогает персонализировать вашу учетную запись)
      </span>
    </div>
    <div :class="avatar_col_class">
      <Avatar
        :avatar="avatar"
        :original_initials="original_initials"
        is_edit
        @change="update"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import Avatar from '../avatar/Avatar.vue';

@Component({
  components: {
    Avatar,
  },
})
export default class AvatarBlock extends Vue {
  @Prop({
    type: [
      String, File,
    ],
    default: '',
    required: true,
  })
  avatar!: string | File;

  @Prop({ type: String, default: '' })
  original_initials!: string;

  @Prop({ type: String, default: '' })
  avatar_col_class!: string;

  update(e: File) {
    this.$emit('updated_avatar', e);
  }
}
</script>

<style module lang="scss">

.avatarBlock {
  width: 100%;
}

.imgTextCol {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (min-width: 600px) and (max-width: 959px) {
  .imgTextCol {
    margin-bottom: 24px;
  }
}

</style>
